// FIXED ADDON SCRIPT - Updated to work with checkbox variant selectors
// The issue was looking for '.variant-radio:checked' when we now use '.variant-checkbox:checked'

document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 Simple Dawn-compatible addon script initializing...');
  
  // Only run on products with addons
  const addonSection = document.querySelector('.addon-products-section');
  if (!addonSection) {
    console.log('❌ No addon section found - script will not run');
    return;
  }
  
  console.log('✅ Addon section found');
  
  // Wait a moment for Dawn to fully initialize, then setup
  setTimeout(() => {
    setupAddonHandling();
  }, 100);
  
  function setupAddonHandling() {
    const productForm = document.querySelector('product-form');
    if (!productForm) {
      console.log('❌ No product-form element found');
      return;
    }
    console.log('✅ Product form element found:', productForm);
    
    const form = productForm.querySelector('form');
    if (!form) {
      console.log('❌ No form element found inside product-form');
      return;
    }
    console.log('✅ Form element found:', form);
    
    // Listen for form submission - EXACTLY as in working version
    form.addEventListener('submit', function(evt) {
      console.log('📝 Form submit event triggered');
      
      const checkedAddons = document.querySelectorAll('.addon-checkbox:checked');
      console.log('🔍 Checked addons found:', checkedAddons.length);
      
      // Log details of each checked addon
      checkedAddons.forEach((addon, index) => {
        console.log(`   Addon ${index + 1}:`, {
          type: addon.getAttribute('data-addon-type'),
          variantId: addon.getAttribute('data-variant-id'),
          price: addon.getAttribute('data-price'),
          sailType: addon.getAttribute('data-sail-type'),
          id: addon.id,
          checked: addon.checked
        });
      });
      
      if (checkedAddons.length === 0) {
        console.log('⚠️ No addons selected - letting Dawn handle normally');
        // Let Dawn handle this normally - don't prevent default
        return;
      }
      
      console.log('🛑 Addons selected - preventing default and handling custom submission');
      evt.preventDefault();
      evt.stopPropagation();
      
      handleAddonSubmission(checkedAddons, productForm, form);
    });
    
    console.log('✅ Event listener successfully attached');
  }
  
  function handleAddonSubmission(checkedAddons, productFormElement, form) {
    console.log('🔧 handleAddonSubmission called with', checkedAddons.length, 'addons');
    
    // FIXED: Look for checked variant CHECKBOX instead of radio
    const selectedVariantCheckbox = document.querySelector('.variant-checkbox:checked');
    if (!selectedVariantCheckbox) {
      console.log('❌ No variant checkbox selected');
      alert('Please select a product variant');
      return;
    }
    
    const mainVariantId = parseInt(selectedVariantCheckbox.getAttribute('data-variant-id'));
    const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value || 1);
    
    console.log('📊 Submission details:', {
      mainVariantId: mainVariantId,
      quantity: quantity,
      addonCount: checkedAddons.length
    });
    
    // Set loading state
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      console.log('🔄 Setting submit button to loading state');
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
    }
    
    addAllItemsToCart(mainVariantId, quantity, checkedAddons)
      .then((response) => {
        console.log('✅ All items added successfully. Response:', response);
        console.log('🔄 Triggering cart UI update...');
        updateCartUI(response);
      })
      .catch(error => {
        console.error('❌ Error adding items:', error);
        alert('Error adding items to cart. Please try again.');
      })
      .finally(() => {
        if (submitButton) {
          console.log('🔄 Removing loading state from submit button');
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
      });
  }
  
  function addAllItemsToCart(mainVariantId, quantity, checkedAddons) {
    console.log('🛒 addAllItemsToCart called');
    console.log('   Main variant ID:', mainVariantId);
    console.log('   Quantity:', quantity);
    console.log('   Checked addons:', checkedAddons.length);
    
    // Build addon properties for the main product
    const addonProperties = {};
    const addonNames = [];
    
    console.log('🏷️ Building addon properties...');
    checkedAddons.forEach((addon, index) => {
      const addonType = addon.getAttribute('data-addon-type');
      const variantId = addon.getAttribute('data-variant-id');
      const price = addon.getAttribute('data-price');
      
      console.log(`   Processing addon ${index + 1}:`, {
        type: addonType,
        variantId: variantId,
        price: price
      });
      
      let displayName = '';
      
      if (addonType === 'insignia') {
        displayName = 'Insignia';
        console.log('     ✅ Added Insignia to display names');
      } else if (addonType === 'cunningham') {
        displayName = 'Cunningham';
        console.log('     ✅ Added Cunningham to display names');
      } else if (addonType === 'sailnumbers') {
        // Get the specific sail number option from the checkbox
        const sailNumberType = addon.getAttribute('data-sail-type');
        displayName = `Sail Numbers: ${sailNumberType}`;
        console.log('     ✅ Added Sail Numbers to display names:', displayName);
      }
      
      if (displayName) {
        addonNames.push(displayName);
        console.log('     ✅ Display name added:', displayName);
      } else {
        console.log('     ❌ No display name created for addon type:', addonType);
      }
    });
    
    if (addonNames.length > 0) {
      addonProperties['Add-ons'] = addonNames.join(', ');
      console.log('✅ Addon properties created:', addonProperties);
    } else {
      console.log('⚠️ No addon properties created');
    }

    // Build items array - main product with properties + addon products
    const items = [];
    
    // 1. Main product with addon properties
    console.log('📦 Adding main product with properties...');
    const mainItem = {
      id: mainVariantId,
      quantity: quantity,
      properties: addonProperties
    };
    items.push(mainItem);
    console.log('   ✅ Main item added:', mainItem);
    
    // 2. Addon products with special property to identify them
    console.log('📦 Adding addon products as separate line items...');
    checkedAddons.forEach((addon, index) => {
      const variantId = addon.getAttribute('data-variant-id');
      const addonType = addon.getAttribute('data-addon-type');
      
      console.log(`   Processing addon ${index + 1} for line item:`, {
        type: addonType,
        variantId: variantId
      });
      
      if (variantId) {
        const addonItem = {
          id: parseInt(variantId),
          quantity: 1,
          properties: {
            '_addon_item': 'true'
          }
        };
        items.push(addonItem);
        console.log(`   ✅ Addon item ${index + 1} added:`, addonItem);
      } else {
        console.log(`   ❌ Addon ${index + 1} missing variant ID`);
      }
    });
    
    console.log('📋 Complete items array being sent:', items);
    
    const sectionsToRender = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble', 'cart-drawer'];
    
    const payload = {
      items: items,
      sections: sectionsToRender.join(','),
      sections_url: window.location.pathname
    };

    console.log('🚀 Sending request to /cart/add.js with payload:', payload);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      console.log('📡 Received response from /cart/add.js:', response.status, response.statusText);
      return response.json();
    })
    .then(response => {
      console.log('📄 Parsed JSON response:', response);
      if (response.status) {
        console.error('❌ Cart add failed with status:', response.status);
        throw new Error(response.description || response.message || 'Error adding items');
      }
      console.log('✅ All items added successfully to cart');
      return response;
    })
    .catch(error => {
      console.error('💥 Error in addAllItemsToCart:', error);
      throw error;
    });
  }
  
  function updateCartUI(response) {
    console.log('🔄 updateCartUI called with response:', response);
    
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');

    console.log('🔍 Cart UI elements found:', {
      cartDrawer: !!cartDrawer,
      cartNotification: !!cartNotification
    });

    // PRIORITY 1: Use the Cart Drawer if it exists
    if (cartDrawer) {
      console.log('🎯 Cart Drawer found. Rendering contents and opening...');
      
      if (typeof cartDrawer.renderContents === 'function') {
        console.log('📝 Calling cartDrawer.renderContents...');
        cartDrawer.renderContents(response);
      } else {
        console.log('⚠️ cartDrawer.renderContents is not a function');
      }
      
      cartDrawer.classList.remove('is-empty');
      console.log('🔓 Removed is-empty class from cart drawer');
      
      if (typeof cartDrawer.open === 'function') {
        setTimeout(() => {
          console.log('🔓 Opening cart drawer...');
          cartDrawer.open();
        }, 100);
      } else {
        console.log('⚠️ cartDrawer.open is not a function');
      }
      return;
    }
    
    // PRIORITY 2: Fallback to Cart Notification
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      console.log('🎯 Cart Drawer not found. Falling back to Cart Notification.');
      
      // Use the sections from the response directly
      if (response && response.sections && response.items && response.items.length > 0) {
        // Find the main product (the one with Add-ons property)
        const mainProduct = response.items.find(item => 
          item.properties && item.properties['Add-ons']
        );
        
        if (mainProduct) {
          console.log('🎯 Found main product with Add-ons in response:', mainProduct);
          
          const cartNotificationResponse = {
            key: mainProduct.key,
            id: mainProduct.id,
            sections: response.sections
          };
          
          console.log('📝 Calling cartNotification.renderContents with:', cartNotificationResponse);
          cartNotification.renderContents(cartNotificationResponse);
          console.log('✅ Cart notification rendered successfully');
        } else {
          console.log('⚠️ No main product with Add-ons found in response');
          window.location = '/cart';
        }
      } else {
        console.log('⚠️ No sections or items in response');
        window.location = '/cart';
      }
      return;
    }

    // FINAL FALLBACK: Redirect to cart page
    console.log('🔄 No modern cart UI found. Redirecting to cart page.');
    window.location = '/cart';
  }
  
  console.log('🎉 Simple Dawn-compatible addon script initialization completed successfully');
});